import TabbedNavigation from 'common/components/tabbed_navigation';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

function mapStateToProps(state, { params, router }) {
  const { subcategory, pageSlug, focusGroupId } = params;
  const urlBase = `/${subcategory}/${pageSlug}/focus-groups/${focusGroupId}/view/results`;

  const tabs = {
    links: [
      {
        url: `${urlBase}/comment`,
        name: 'comments',
      },
      {
        url: `${urlBase}/votes`,
        name: 'votes',
      },
    ]
  };

  return {
    projectUrl: params.projectUrl || '',
    tabs,
    router,
  };
}

export default withRouter(connect(mapStateToProps, { push })(TabbedNavigation));



// WEBPACK FOOTER //
// ./focus_groups/containers/result_tabs.js